import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from '@material-ui/core';
import { TEXT } from '../../shared_components';

const ConfirmActionDialog = ({ title, description, content, confirmText, confirmColor = 'primary', loading = false, onClose, onConfirm }) => (
  <Dialog open onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
    <DialogTitle>
      <Typography variant="h6" style={{ fontWeight: 700 }}>{title}</Typography>
      {description ? (
        <Typography variant="body2" style={{ color: TEXT.secondary, marginTop: 2 }}>{description}</Typography>
      ) : null}
    </DialogTitle>
    <DialogContent dividers>
      <Typography variant="body2" style={{ color: TEXT.primary }}>{content}</Typography>
    </DialogContent>
    <DialogActions style={{ padding: '12px 24px' }}>
      <Button onClick={onClose} disabled={loading}>Go Back</Button>
      <Button variant="contained" color={confirmColor} onClick={onConfirm} disabled={loading}>
        {loading ? <CircularProgress size={20} color="inherit" /> : confirmText}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmActionDialog;
